import {
  WppIconError,
  WppIconPending,
  WppIconSuccess,
  WppIconWarning,
  WppTooltip,
} from '@wppopen/components-library-react'
import clsx from 'clsx'

import SpinnerSVG from 'assets/icons/spinner.svg'
import { SyncStatus } from 'types/Project'

import styles from './StatusNotification.module.scss'

interface Props {
  statusType?: SyncStatus
  message: string
  className?: string
}
const StatusNotification = ({ statusType, className }: Props) => {
  return (
    <div className={clsx(styles.statusText, className)}>
      {statusType === SyncStatus.SYNCED && (
        <WppTooltip text="Synced" externalClass={clsx(styles.StatusNotification, 'w-fit', styles.success)}>
          <WppIconSuccess color="#3AAD2C" />
        </WppTooltip>
      )}
      {statusType === SyncStatus.WARNING && (
        <WppTooltip text="Brief changed" externalClass={clsx(styles.StatusNotification, 'w-fit', styles.warning)}>
          <WppIconWarning />
        </WppTooltip>
      )}
      {statusType === SyncStatus.ERROR && (
        <WppTooltip text="Sync Error" externalClass={clsx(styles.StatusNotification, 'w-fit', styles.error)}>
          <WppIconError />
        </WppTooltip>
      )}
      {statusType === SyncStatus.PENDING ||
        (statusType === SyncStatus.IN_PROGRESS && (
          <WppTooltip text="Sync Pending" externalClass={clsx(styles.StatusNotification, 'w-fit')}>
            <WppIconPending color="#191919" />
          </WppTooltip>
        ))}
      {statusType === SyncStatus.SYNCING && (
        <WppTooltip text="Syncing" externalClass={clsx(styles.StatusNotification, 'w-fit', styles.error)}>
          <img src={SpinnerSVG} alt="spinner" className={styles.spinner} />
        </WppTooltip>
      )}
      {statusType === SyncStatus.REJECTED && (
        <WppTooltip text="Rejected" externalClass={clsx(styles.StatusNotification, 'w-fit', styles.warning)}>
          <WppIconWarning />
        </WppTooltip>
      )}
      {statusType === SyncStatus.BRIEF_PENDING && (
        <WppTooltip
          text="Brief not yet uploaded"
          externalClass={clsx(styles.StatusNotification, 'w-fit', styles.warning)}
        >
          <WppIconWarning />
        </WppTooltip>
      )}
    </div>
  )
}

export default StatusNotification
